var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_crsl", style: { width: _vm.width, height: _vm.height } },
    [
      _c(
        "div",
        {
          staticClass: "_crsh",
          on: {
            wheel: function($event) {
              $event.preventDefault()
              return _vm.wheel($event)
            }
          }
        },
        [
          _c(
            "div",
            {
              ref: "outer",
              staticClass: "_crso",
              class: { _cios: _vm.$device.ios, _csnap: !_vm.$device.hasMouse },
              style: _vm.hidebar,
              on: { scroll: _vm.scroll }
            },
            [
              _c(
                "div",
                {
                  ref: "inner",
                  staticClass: "_crsi",
                  on: { mousedown: _vm.mousedown, touchstart: _vm.touchstart }
                },
                [_vm._t("default")],
                2
              )
            ]
          )
        ]
      ),
      _c(
        "ol",
        {
          staticClass: "_crst",
          class: { _hide: _vm.child.length < 2 },
          attrs: { role: "tablist" }
        },
        _vm._l(_vm.child, function(c, i) {
          return _c("li", {
            attrs: { role: "tab", "aria-selected": _vm.active == i },
            on: {
              click: function($event) {
                return _vm.goto(i)
              }
            }
          })
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }